import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './cbpRatesInitialState';
import {
  _setCboRteStartMthId,
  _setCboDefaultWeeklyQty,
  _setCboRteAmt,
  _setCboRteCmt,
  _setCboRteDcpAmt,
  _setCboRteDcpMthSettlementYn,
  _setCboRteDcpQty,
  _setCboRteDcpUnitAmt,
  _setCboRteTargetPct,
  _setCbpCnyMnRte,
  _setCbpCnyMxRte,
  _setCbpRteInactive,
  _setCboRteEndMthId,
  _setCboRteTmtTypId,
} from './cbpRatesActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getCbpRatesFormData = createAsyncThunk(
  'stop/getCbpRatesFormData',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const cbpRatesFormDataSlice = createSlice({
  name: 'stop/cbpRatesFormDataSlice',
  initialState,
  reducers: {
    newCbpRates: (state, action) => action.payload,
    setCboRteStartMthId: _setCboRteStartMthId,
    setCboRteEndMthId: _setCboRteEndMthId,
    setCboRteTmtTypId: _setCboRteTmtTypId,
    setCboRteAmt: _setCboRteAmt,
    setCbpCnyMnRte: _setCbpCnyMnRte,
    setCbpCnyMxRte: _setCbpCnyMxRte,
    setCboRteDcpUnitAmt: _setCboRteDcpUnitAmt,
    setCboDefaultWeeklyQty: _setCboDefaultWeeklyQty,
    setCboRteDcpQty: _setCboRteDcpQty,
    setCboRteDcpAmt: _setCboRteDcpAmt,
    setCboRteTargetPct: _setCboRteTargetPct,
    setCboRteCmt: _setCboRteCmt,
    setCbpRteInactive: _setCbpRteInactive,
    setCboRteDcpMthSettlementYn: _setCboRteDcpMthSettlementYn,
    //resetCbpRatesFormData: () => null,
  },
  extraReducers: {
    [getCbpRatesFormData.fulfilled]: (state, action) => action.payload,
  },
});

export const {
  newCbpRates,
  setCboRteStartMthId,
  setCboRteEndMthId,
  setCboRteTmtTypId,
  setCboRteAmt,
  setCbpCnyMnRte,
  setCbpCnyMxRte,
  setCboRteDcpUnitAmt,
  setCboDefaultWeeklyQty,
  setCboRteDcpQty,
  setCboRteDcpAmt,
  setCboRteTargetPct,
  setCboRteCmt,
  setCbpRteInactive,
  setCboRteDcpMthSettlementYn,
  //resetProfA2ReferenceData
} = cbpRatesFormDataSlice.actions;

export default cbpRatesFormDataSlice.reducer;
